import { PRIEST_SPECS } from './specs/priest'
import { BuildData } from 'web/data/models'
import { PRIEST_TALENTS } from './talents/priest'
import { PRIEST_SPELLS } from './spells/priest'
import { ESSENCE_MODIFIERS } from './modifiers/essences'
import { DRUID_SPECS } from './specs/druid'
import { DRUID_SPELLS } from './spells/druid'
import { DRUID_TALENTS } from './talents/druid'
import { WARRIOR_SPECS } from './specs/warrior'
import { DH_SPECS } from './specs/dh'
import { MONK_TALENTS } from './talents/monk'
import { MONK_SPECS } from './specs/monk'
import { PALADIN_SPECS } from './specs/paladin'
import { SHAMAN_SPECS } from './specs/shaman'
import { DH_SPELLS } from './spells/dh'
import { MONK_SPELLS } from './spells/monk'
import { PALADIN_SPELLS } from './spells/paladin'
import { SHAMAN_SPELLS } from './spells/shaman'
import { WARRIOR_SPELLS } from './spells/warrior'
import { SHAMAN_TALENTS } from './talents/shaman'
import { CooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { vopRank3Resolver } from './resolvers/vop-resolver'
import { assertDefined } from 'web/utils/utils'
import { SPELL_RESOLVERS } from './resolvers/resolvers'
import { createBuildData } from 'web/data/core-data'

const specs = {
    ...DH_SPECS,
    ...DRUID_SPECS,
    ...MONK_SPECS,
    ...PALADIN_SPECS,
    ...PRIEST_SPECS,
    ...SHAMAN_SPECS,
    ...WARRIOR_SPECS,
}

const spells = {
    ...DH_SPELLS,
    ...DRUID_SPELLS,
    ...MONK_SPELLS,
    ...PALADIN_SPELLS,
    ...PRIEST_SPELLS,
    ...SHAMAN_SPELLS,
    ...WARRIOR_SPELLS,
}

const talents = {
    ...PRIEST_TALENTS,
    ...DRUID_TALENTS,
    ...MONK_TALENTS,
    ...SHAMAN_TALENTS,
}

const modifiers = {
    ...ESSENCE_MODIFIERS,
}

const resolvers = {
    ...SPELL_RESOLVERS,
}

export const Build_830_1: BuildData = createBuildData({
    buildVersion: '830_1',
    spells,
    specs,
    talents,
    modifiers,

    __CooldownResolver: (spellId: string): CooldownResolver => {
        let spell = spells[spellId]
        assertDefined(spell)

        const maybeResolver = resolvers[spell.id]

        if (maybeResolver != null) {

            return (spell, player) => {
                return vopRank3Resolver(spell, player, maybeResolver(spell, player))
            }

        }

        return (spell, player) => vopRank3Resolver(spell, player, spell.cooldown)
    }
})
